/* eslint-disable max-len */
/** Root paths */
const LIST = "/surveys"
const SCHEDULE = "/survey/:scheduleId"
const ADD = "/survey/create"

/** Nested */
const EDIT = `${SCHEDULE}/edit`
const ANALYSIS = `${SCHEDULE}/analysis`


/** Helpers */
const _makePath = (path, options = {}) => {
  const {namespace = "", title = "", values = {}} = options
  return {path, url: `${namespace}${path}`, title, values}
}

export default {
  homepage: _makePath(LIST, {title: "insights.sitemap.scheduleList"}),

  analysis: _makePath(ANALYSIS, {title: "insights.sitemap.scheduleAnalysis", values: {schedule: " "}}),

  scheduleAdd: _makePath(ADD, {title: "insights.sitemap.scheduleAdd"}),
  wizardStep1: _makePath("/step-1", {namespace: ADD, title: "insights.sitemap.wizard.step1"}),
  wizardStep2: _makePath("/step-2", {namespace: ADD, title: "insights.sitemap.wizard.step1"}),
  wizardStep3: _makePath("/step-3/:scheduleId", {namespace: ADD, title: "insights.sitemap.wizard.step1"}),

  scheduleEdit: _makePath(EDIT, {title: "insights.sitemap.scheduleEdit", values: {schedule: " "}}),
  scheduleEditSummary: _makePath(`${EDIT}/summary`, {title: "insights.sitemap.scheduleEditSummary", values: {schedule: " "}}),
  scheduleSettings: _makePath("/survey-settings", {namespace: EDIT, title: "Schedule settings"}),
  emailSettings: _makePath("/email-settings", {namespace: EDIT, title: "Email settings"}),
  questionLibrary: _makePath("/question-library", {namespace: EDIT, title: "Question Library"}),

  reports: _makePath("/reports", {title: "insights.sitemap.reports"}),

  chatroom: _makePath("/chat/:roomId?", {title: "insights.sitemap.chatroom.title"}),

  mySurveys: _makePath("/my-surveys", {title: "My Surveys"})
}
